<template>
  <div id="permission">
    <div class="content">
      <div class="wrap">
        <v-icon name="lock"
                scale="5"></v-icon>
        <p class="tips">{{msg}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import "vue-awesome/icons/lock";
  export default {
    name: "Permission",
    data() {
      return {
        // 汉字转码
        msg: decodeURIComponent(this.$route.query.msg) || "非常抱歉，您没有操作权限"
      };
    },
    components: {
      "v-icon": () => import("vue-awesome/components/Icon")
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  #permission {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      width: 890px;
      height: 710px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $color_white;
      background-color: $block_bg_color_base;
      .wrap {
        width: 100%;
        height: 135px;
        /*margin: 250px 0 0;*/
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .tips {
          font-size: 20px;
        }
      }
    }
  }
</style>